import React, { useState } from 'react'

import RepeatVideosModal from './RepeatVideosModal'

import useViewport from '../../modules/viewport/useViewport'

import style from './style.module.scss'

const RepeatVideos = React.memo(
  () => {
    const [showModal, setShowModal] = useState(false)

    const viewport = useViewport()

    return (
      <div className={`${style.RepeatVideos} ${viewport.mobile ? style.mobile : ''}`}>
        <span
          data-testid="SW-NavigationPanel-RepeatVideos"
          className={style.RepeatVideosButton}
          role="button"
          onClick={() => void setShowModal(true)}
        >
          <i className="icon-aytmfd-qvideo-replay" role="presentation" />
        </span>
        {showModal ? <RepeatVideosModal onClose={() => void setShowModal(false)} /> : null}
      </div>
    )
  },
  () => true
)

RepeatVideos.displayName = 'RepeatVideos'

export default RepeatVideos
